<template>
	<div class="brick">
		<div class="half_tbl_box">
			<div class="left_big_tbl">
				<div class="view_inner">
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:130px;" />
							<col style="width:400px;" />
							<col style="width:190px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Code</th>
								<td colspan="3">
									<input type="text" v-model.trim="partner.code" class="tbl_int ssm2_int" ref="code" v-bind:readonly="mode == 'detail'" v-bind:disabled="mode == 'detail'" @blur="makePassword" />
									<input type="text" v-if="user.company_id != 'newjigu'" v-model.trim="partner.alt_code" class="tbl_int ssm2_int mgr_15" style="margin-left:5px;" placeholder="Alternative Code" />
									<span v-show="!initial_partner_type">
										<label class="mgr_10"><input type="radio" value="C" v-model="partner.partner_type" @change="addTabPages()" /> Customer</label>
										<label class="mgr_10"><input type="radio" value="V" v-model="partner.partner_type" @change="addTabPages()" /> Vendor</label>
										<label class="mgr_10"><input type="radio" value="B" v-model="partner.partner_type" @change="addTabPages()" /> Both</label>
									</span>
									<button v-if="mode == 'add'" v-bind:disabled="!partner.code" class="gray_bt" @click="checkDup()">Check Dup.</button>
									<button v-else-if="modifiable || user.memo_mgmt" class="gray_bt" @click="openModal('Memo')"><font :color="partner.memo ? 'red' : 'black'">Memo</font></button>
									<template v-if="mode == 'detail'">
										<input type="text" v-model.trim="search_partner_code" class="tbl_int ssm2_int" placeholder="Code to Search" @keypress.enter="findPartner()" />
										<a href="javascript:;" type="button" class="search_bt" @click="findPartner()">Search</a>
									</template>
								</td>
							</tr>
							<tr>
								<th>Name / Company</th>
								<td><input type="text" v-model.trim="partner.name" class="tbl_int" /></td>
								<th>
									<span style="float:left;"><button v-if="mode == 'add'" v-bind:disabled="!partner.name" class="gray_bt" @click="checkDupName()">Check Dup.</button></span>
									<div style="margin-top:5px;">Biz Type</div>
								</th>
								<td>
									<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="businessTypes" v-model="partner.business_type_code" @set-code="setBusinessType"/></span>
									<!-- <a v-if="partModifiable" href="javascript:;" class="gray_bt" @click="updateBusinessType()">Update</a> -->
									<!-- <em class="lt_text"> {{ partner.business_type_name }}</em> -->
								</td>
							</tr>
							<tr>
								<th>Full Name</th>
								<td><input type="text" v-model.trim="partner.full_name" class="tbl_int" /></td>
								<th>Grade</th>
								<td>
									<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="grades" v-model="partner.grade_code" @set-code="setGrade"/></span>
									<!-- <em class="lt_text"> {{ partner.grade_name }}</em> -->
								</td>
							</tr>
							<tr>
								<th>DBA</th>
								<td><input type="text" v-model.trim="partner.dba_name" class="tbl_int" /></td>
								<th><font color="red">Notice</font></th>
								<td><input type="text" v-model.trim="partner.notice" class="tbl_int" style="color:red;" /></td>
							</tr>
							<tr>
								<th>Description</th>
								<td colspan="3">
									<input type="text" v-model.trim="partner.description" class="tbl_int" />
									<!-- <a v-if="partModifiable" href="javascript:;" class="gray_bt" @click="updateDescription()">Update</a> -->
								</td>
							</tr>
							<tr>
								<th>Terms Conditions</th>
								<td><input type="checkbox" v-model.trim="partner.retail_terms_conditions" disabled /> {{ partner.retail_terms_conditions_date | moment('MM-DD-YYYY HH:mm:ss') }}</td>
								<td colspan="2">
									<label for="active_yn" style="margin-left:5px;"> <input type="checkbox" id="active_yn" v-model="partner.active_yn" true-value="Y" false-value="N" />Active</label>
									<label for="blocked" style="margin-left:15px;"> <input type="checkbox" id="blocked" v-model="partner.blocked" @change="blockStatusChanged" />Blocked</label>
									<select v-model="partner.block_reason" class="tbl_select lm_int" :disabled="!partner.blocked">
										<option v-for="reason in this.$partnerBlockReasons" v-bind:value="reason" v-bind:key="reason">{{ reason }}</option>
									</select>
								</td>
							</tr>
							<tr>
								<th>YTD Sales</th>
								<td colspan="3">
									<currency-input type="text" v-model.trim="partner.ytd" class="tbl_int ssm_int al_right" readonly />
									<span class="mgl_15"><b>Last Invoice Date</b></span>
									<input type="text" v-model.trim="partner.last_invoice_date" class="tbl_int ssm_int al_right" readonly />
									<span class="mgl_15"><b>Last Invoice Amount</b></span>
									<currency-input type="text" v-model.trim="partner.last_invoice_amount" class="tbl_int ssm_int al_right" readonly />
									<a href="javascript: void(0);" class="gray_bt" style="float:right;" @click="openModal('ShipToAddressManagement')">Ship To Addr. Management</a>
								</td>
							</tr>
							<tr>
								<td colspan="4">
									<!-- <h4 class="view_title_h4">{{ tabTitle }}</h4> -->
									<div class="tab_wrap w_16" style="padding-top:20px;padding-left:30px;padding-right:300px;">
										<ul>
											<li v-for="(tabPage, index) in tabPages" v-bind:key="index">
												<a href="javascript:;" @click="selectTab(index)" :class="{ on: currentTabPage == index }">{{ tabPages[index] }}</a>
											</li>
										</ul>
									</div>

									<!-- General Info -->
									<div v-show="currentTabPage == 0" :style="'height:' + tabHeight + 'px;'">
										<table class="view_tbl" border="0">
											<colgroup>
												<col style="width:130px;" />
												<col style="width:300px;" />
												<col style="width:130px;" />
												<col style="" />
											</colgroup>
											<tbody>
												<tr>
													<th>Owner Name</th>
													<td><input type="text" v-model.trim="partner.owner_name" class="tbl_int" /></td>
													<th>Owner Info</th>
													<td><input type="text" v-model.trim="partner.owner_info" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>Tax ID</th>
													<td><input type="text" v-model.trim="partner.tax_id" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>SSN</th>
													<td><input type="text" v-model.trim="partner.owner_ssn" class="tbl_int " /></td>
												</tr>
												<tr>
													<th>License No</th>
													<td><input type="text" v-model.trim="partner.owner_license_no" class="tbl_int " /></td>
												</tr>
												<tr>
													<th>Open / Entered Date</th>
													<td>
														<CustomDatePicker v-model="partner.open_date" />
													</td>
													<th>Specialty</th>
													<td>
														<input class="tbl_int" style="width:200px;" type="text" :value="'B-' + partner.bounce_count + '     R-' + partner.return_count + '     A-' + partner.average_paid_days" readonly />
													</td>
												</tr>
												<tr>
													<th>Race</th>
													<td>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="races" v-model="partner.race_code" @set-code="setRace"/></span>
														<!-- <em class="lt_text"> {{ partner.race_name }}</em> -->
													</td>
													<th></th>
													<td>(* B : Bounce Count, R : Return Count, A : Average Paid Days)</td>
												</tr>
												<tr>
													<th style="padding-top:10px;">Address</th>
													<td style="padding-top:10px;" colspan="3">
														<input class="tbl_int" style="width:400px;" type="text" id="address_detail" v-model.trim="partner.address_detail" />
														<a href="javascript:;" class="gray_bt" @click="clearAddress()" style="margin-left:5px;">Clear</a>
														<span style="padding-left:15px;"><b>Territory</b></span>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="territories" v-model="partner.territory_code" :showDesc="false" @set-code="setTerritory"/></span>
														<br />
														<input class="tbl_int" style="width:400px;" type="text" id="address_detail2" v-model.trim="partner.address_detail2" placeholder="Address Line 2 (Optional)" />
														<span style="padding-left:62px;"><b>Shipping Info.</b></span>
														<input class="tbl_int" style="width:200px;" type="text" v-model.trim="partner.ship_info" />
													</td>
												</tr>
												<tr>
													<th>City</th>
													<td colspan="3">
														<input type="text" class="tbl_int mm_int" placeholder="NEW YORK" v-model.trim="partner.address_city" />
														<input type="text" class="tbl_int sm_int" placeholder="NY" v-model.trim="partner.address_state" style="margin-left:5px;" />
														<input type="text" class="tbl_int ssm_int" placeholder="10029" v-model.trim="partner.address_zipcode" style="margin-left:5px;" @blur="makePassword" />
														<!-- <input type="text" class="tbl_int ssm_int" placeholder="US" v-model.trim="partner.country" style="margin-left:5px;" /> -->
														<span class="int_type_no_border mgr_10">
															<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model.trim="partner.country" style="margin-left:5px;" />
														</span>
														<a href="#" class="gray_bt" id="map" type="button" style="margin-left:5px;" @click="openModal('GoogleMap')">Map</a>
														<a href="#" class="gray_bt" id="map" type="button" @click="confirmAddress()">Confirm Address</a>
													</td>
												</tr>
												<tr>
													<th>Telephone 1 / 2 / SMS</th>
													<td colspan="3">
														<input type="text" v-model.trim="partner.telephone" class="tbl_int quarter_int" /> / <input type="text" v-model.trim="partner.telephone2" class="tbl_int quarter_int" /> /
														<input type="text" v-model.trim="partner.telephone_sms" class="tbl_int quarter_int" />
													</td>
												</tr>
												<tr>
													<th>Manager Phone(s)</th>
													<td colspan="3">
														<input type="text" v-model.trim="partner.manager_telephone" class="tbl_int quarter_int" /> / <input type="text" v-model.trim="partner.manager_telephone2" class="tbl_int quarter_int" /> /
														<input type="text" v-model.trim="partner.manager_telephone3" class="tbl_int quarter_int" />
													</td>
												</tr>
												<tr>
													<th>Fax</th>
													<td><input type="text" v-model.trim="partner.fax" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>Email 1 / 2</th>
													<td colspan="3"><input type="text" v-model.trim="partner.email" class="tbl_int quarter_int" /> / <input type="text" v-model.trim="partner.email2" class="tbl_int quarter_int" /></td>
												</tr>
												<tr>
													<th>Password</th>
													<td><input type="text" v-model.trim="partner.password" class="tbl_int" /></td>
												</tr>
											</tbody>
										</table>
									</div>

									<!-- Biz Process Info -->
									<div v-show="currentTabPage == 1" :style="'height:' + tabHeight + 'px;'">
										<table class="view_tbl" border="0">
											<colgroup>
												<col style="width:130px;" />
												<col />
											</colgroup>
											<tbody>
												<tr>
													<th>Delivery Type</th>
													<td>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="deliveryTypes" v-model="partner.delivery_type_code" @set-code="setDeliveryType"/></span>
														<!-- <em class="lt_text"> {{ partner.delivery_type_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>Ship Charge</th>
													<td>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="shipCharges" v-model="partner.ship_charge_code" @set-code="setShipCharge"/></span>
														<!-- <em class="lt_text"> {{ partner.ship_charge_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>Sales Group</th>
													<td>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="partner.sales_group_code" @set-code="setSalesGroup"/></span>
														<!-- <em class="lt_text"> {{ partner.sales_group_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>Sales Man</th>
													<td>
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="reformattedSalesmans" v-model="partner.salesman_id" @set-code="setSalesman"/></span>
														<!-- <em class="lt_text"> {{ partner.sales_group_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>Monthly Credit Limit</th>
													<td><currency-input type="text" v-model.trim="partner.credit_limit" class="tbl_int ssm_int al_right" /></td>
												</tr>
												<tr>
													<th>Total Credit Limit</th>
													<td><currency-input type="text" v-model.trim="partner.total_credit_limit" class="tbl_int ssm_int al_right" /></td>
												</tr>
												<tr>
													<th></th>
													<td>
														<label for="cod_free_yn" style="margin-left:5px;"> <input type="checkbox" id="cod_free_yn" v-model="partner.cod_free_yn" true-value="Y" false-value="N" />COD Charge Free</label>
													</td>
												</tr>
												<tr>
													<th></th>
													<td>
														<label for="handling_charge_free_yn" style="margin-left:5px;">
															<input type="checkbox" id="handling_charge_free_yn" v-model="partner.handling_charge_free_yn" true-value="Y" false-value="N" />Handling Charge Free</label
														>
													</td>
												</tr>
												<tr>
													<th></th>
													<td>
														<label for="invoice_date_editable" style="margin-left:5px;"> <input type="checkbox" id="invoice_date_editable" v-model="partner.invoice_date_editable" />Invoice Date Editable</label>
													</td>
												</tr>
												<tr>
													<th></th>
													<td>
														<label for="show_credit" style="margin-left:5px;"> <input type="checkbox" id="show_credit" v-model="partner.show_credit" />Show Credit</label>
													</td>
												</tr>
											</tbody>
										</table>
									</div>

									<!-- Accounting Info -->
									<div v-show="currentTabPage == 2" :style="'height:' + tabHeight + 'px;'">
										<table class="view_tbl" border="0">
											<colgroup>
												<col style="width:130px;" />
												<col style="width:300px;" />
												<col style="width:130px;" />
												<col style="" />
											</colgroup>
											<tbody>
												<tr>
													<th>Bill To</th>
													<td colspan="3">
														<PartnerSelect v-model="partner.bill_to_code" :initialName="partner.bill_to_name" :activeOnly="true" ph="If different" />
														<!-- <span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="paymentTerms" v-model="partner.payment_term_code" @set-code="setPaymentTerm"/></span> -->
														<!-- Select bill partner, if different -->
													</td>
												</tr>
												<tr>
													<th>Payment Term</th>
													<td colspan="2">
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="paymentTerms" v-model="partner.payment_term_code" @set-code="setPaymentTerm"/></span>
														<!-- <em class="lt_text"> {{ partner.payment_term_name }}</em> -->
													</td>
													<td></td>
												</tr>
												<tr>
													<th>Receipt Type</th>
													<td colspan="2">
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="recipetTypes" v-model="partner.receipt_type_code" @set-code="setReceiptType"/></span>
														<!-- <em class="lt_text"> {{ partner.receipt_type_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>A/R Type</th>
													<td colspan="2">
														<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="arTypes" v-model="partner.ar_type_code" @set-code="setArType"/></span>
														<!-- <em class="lt_text"> {{ partner.ar_type_name }}</em> -->
													</td>
												</tr>
												<tr>
													<th>Contact Person</th>
													<td><input type="text" v-model.trim="partner.attention_name" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>Contact Phone</th>
													<td><input type="text" v-model.trim="partner.attention_phone" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>Contact Address</th>
													<td><input type="text" v-model.trim="partner.attention_address" class="tbl_int" /></td>
												</tr>
												<tr>
													<th>Card Info</th>
													<td colspan="3"><input type="text" :title="partner.card_info" v-model.trim="partner.card_info" class="tbl_int" style="width:550px;" /></td>
												</tr>
												<tr>
													<th>Bank Info</th>
													<td colspan="3"><input type="text" :title="partner.bank_info" v-model.trim="partner.bank_info" class="tbl_int" style="width:550px;" /></td>
												</tr>
												<tr>
													<th>UPS Account Number</th>
													<td><input type="text" v-model.trim="partner.ups_account_number" class="tbl_int" /></td>
												</tr>
											</tbody>
										</table>
									</div>

									<!-- Owner Info -->
									<div v-show="currentTabPage == 3" :style="'height:' + tabHeight + 'px;'">
										<table class="view_tbl" border="0">
											<colgroup>
												<col style="width:130px;" />
												<col style="width:300px;" />
												<col style="width:130px;" />
												<col style="" />
											</colgroup>
											<tbody>
												<tr>
													<th style="padding-top:10px;">Address</th>
													<td style="padding-top:10px;" colspan="3">
														<input class="tbl_int half_int" type="text" id="owner_address_detail" v-model.trim="partner.owner_address_detail" />
														<a href="javascript:;" class="gray_bt" @click="clearOwnerAddress()" style="margin-left:5px;">Clear</a>
													</td>
												</tr>
												<tr>
													<th>City</th>
													<td colspan="3">
														<input type="text" class="tbl_int mm_int" placeholder="NEW YORK" v-model.trim="partner.owner_address_city" />
														<input type="text" class="tbl_int sm_int" placeholder="NY" v-model.trim="partner.owner_address_state" style="margin-left:5px;" />
														<input type="text" class="tbl_int ssm_int" placeholder="10029" v-model.trim="partner.owner_address_zipcode" style="margin-left:5px;" />
														<!-- <input type="text" class="tbl_int ssm_int" placeholder="US" v-model.trim="partner.owner_country" style="margin-left:5px;" /> -->
														<span class="int_type_no_border">
															<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model.trim="partner.owner_country" style="margin-left:5px;" />
														</span>
													</td>
												</tr>
												<tr>
													<th>Phone</th>
													<td><input type="text" v-model.trim="partner.owner_phone" class="tbl_int " /></td>
													<th></th>
													<td></td>
												</tr>
												<tr>
													<th>Cell Phone</th>
													<td><input type="text" v-model.trim="partner.owner_cell_phone" class="tbl_int " /></td>
												</tr>
												<tr>
													<th>Email</th>
													<td><input type="text" v-model.trim="partner.owner_email" class="tbl_int " /></td>
												</tr>
												<tr>
													<th>Date of Birth</th>
													<td><CustomDatePicker v-model="partner.owner_dob" /></td>
												</tr>
											</tbody>
										</table>
									</div>

									<div v-show="currentTabPage == 4" :style="'height:' + tabHeight + 'px;padding-left:50px;padding-right:220px;'">
										<div>
											<em class="lt_text">Doc Type</em>
											<span class="int_type_no_border"> <CodeSelect :codes="docTypes" v-model="doc_type_code" @set-code="setDocType" /> </span>
											<button v-if="modifiable" :disabled="mode == 'add' || !doc_type_code" @click="uploadFile">Upload</button>
											<input type="file" ref="uploadFile" class="file_input_hidden" @change="uploadFileConfirm()" />
										</div>
										<table id="item_list" class="list_tbl">
											<thead>
												<tr>
													<th style="text-align:center;width:25%;">Type</th>
													<th style="text-align:center;width:35%;">FileName</th>
													<th style="text-align:center;width:10%">FileSize</th>
													<th style="text-align:center;width:20%;">Modified Date</th>
													<th style="text-align:center;width:10%">Delete</th>
												</tr>
											</thead>

											<tbody>
												<tr v-for="doc in docs" v-bind:key="doc.doc_no">
													<td>{{ doc.doc_type_name }}</td>
													<td>
														<a href="javascript:;" @click="downloadFile(doc)">{{ doc.original_filename }}</a>
													</td>
													<td style="text-align:right;">{{ doc.filesize | commaSeparated }}</td>
													<td>{{ doc.upd_dt ? doc_upd_dt : doc.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
													<td><button v-if="modifiable" @click="deleteFile(doc)">Delete</button></td>
												</tr>
											</tbody>
										</table>

										<!-- <div class="fixed-table-container">
									<div class="table-wrapper">
										<table id="item_list" class="list_tbl">
											<thead>
												<tr>
													<th style="text-align:center;width:25%;"><div class="th-text">Type</div></th>
													<th style="text-align:center;width:35%;"><div class="th-text">FileName</div></th>
													<th style="text-align:center;width:10%"><div class="th-text">FileSize</div></th>
													<th style="text-align:center;width:20%;"><div class="th-text">Modified Date</div></th>
													<th style="text-align:center;width:10%"><div class="th-text">Delete</div></th>
												</tr>
											</thead>

											<tbody>
												<tr v-for="doc in docs" v-bind:key="doc.doc_no">
													<td>{{ doc.doc_type_name }}</td>
													<td>
														<a href="javascript:;" @click="downloadFile(doc)">{{ doc.original_filename }}</a>
													</td>
													<td style="text-align:right;">{{ doc.filesize | commaSeparated }}</td>
													<td>{{ doc.upd_dt ? doc_upd_dt : doc.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
													<td><button v-if="modifiable" @click="deleteFile(doc)">Delete</button></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div> -->
									</div>

									<!-- Shopify Info -->
									<div v-show="currentTabPage == 5 && partner.partner_type !== 'V'" :style="'height:' + tabHeight + 'px;'">
										<table class="view_tbl" border="0">
											<colgroup>
												<col style="width:130px;" />
												<col style="width:350px;" />
												<col style="width:130px;" />
												<col style="" />
											</colgroup>
											<tbody v-if="mode === 'detail'">
												<tr>
													<th>Shop Name</th>
													<td>
														<span class="int_type_no_border">
															<select v-model="selected_third_party_store_no" class="tbl_select">
																<option v-for="(store, index) in third_party_store_list" :key="index" :value="store.store_no">{{ store.store_name }}</option>
															</select>
														</span>
													</td>
													<td></td>
													<td></td>
												</tr>
												<tr v-for="(id, index) in third_party_customer_ids" :key="index">
													<td></td>
													<td colspan="3">
														<span class="mgr_10">{{ id.program_customer_id }}</span>
														<a href="javascript:void(0);" @click="deleteThirdPartyCustomer(id.cust_no)" class="gray_bt">Del.</a>
													</td>
												</tr>
												<tr>
													<th style="padding-top: 10px;">New Cust.</th>
													<td style="padding-top: 10px;"><input type="text" class="tbl_int" v-model.trim="new_program_customer_id" placeholder="Input Excluding 'gid://shopify/Customer/' From Shopify ID." /></td>
													<td style="padding-top: 10px;"><a href="javascript:void(0);" @click="addThirdPartyCustomer()" class="gray_bt">Add</a></td>
													<td style="padding-top: 10px;"></td>
												</tr>
											</tbody>
											<tbody v-else>
												<tr>
													<td colspan="4" class="al_center">
														<b>Register Customer First.</b>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</td>
							</tr>
							<tr v-if="user.admin_yn == 'Y'">
								<td colspan="4">Created : {{ partner.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ partner.crt_user }}, Last updated : {{ partner.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ partner.upd_user }}</td>
							</tr>
							<tr v-else-if="!modifiable && partModifiable">
								<td colspan="4" class="al_right">Updatable Info. : Business Type, Description, Owner Info, Contact Information Except Telephone 1</td>
							</tr>
						</tbody>
					</table>

					<div class="view_bottom_bt">
						<!-- <a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="submit(false)">Save & Return To Previous Page</a> -->
						<a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="submit(false)">Save & Return To Previous Page</a>
						<a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="submit(true)">Save Only</a>
						<a v-if="!modifiable && partModifiable" href="javascript:;" type="button" class="search_bt" @click="updatePart()">Save Part</a>
						<!-- <a href="javascript:;" type="button" :disabled="mode == 'add'" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="delPartner()" class="delete_button">Delete</a> -->
						<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="goBack">Cancel</a>
					</div>
				</div>
			</div>

			<div class="right_small_tbl">
				<div class="mgb_5">
					<h4 class="inner_h5">Block History</h4>
					<div class="fixed-table-container" style="height: 235px; overflow-x: auto;">
						<!-- <div class="table-wrapper" style="height:410px;"> -->
						<div class="table-wrapper">
							<table id="item_list" class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:180px;"><div class="th-text">Date Time</div></th>
										<th style="text-align:center;width:180px;"><div class="th-text">Operator ID</div></th>
										<th style="text-align:center;"><div class="th-text">Block Reason</div></th>
									</tr>
								</thead>

								<tbody>
									<tr v-for="h in blockHistory" v-bind:key="h.history_no">
										<td>{{ h.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
										<td>{{ h.crt_user }}</td>
										<td>{{ h.block_reason }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<div class="mgb_5">
					<h4 class="inner_h5">
						<template v-if="arViewable">Invoice with AR Amount</template>
						<template v-else>&nbsp;</template>
					</h4>
					<div class="fixed-table-container" style="height: 235px; overflow-x: auto;">
						<!-- <div class="table-wrapper" style="height:410px;"> -->
						<div v-if="arViewable" class="table-wrapper">
							<table class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:110px;"><div class="th-text">Inv No.</div></th>
										<th style="text-align:center;width:80px;"><div class="th-text">Inv Date</div></th>
										<th style="text-align:center;width:90px;"><div class="th-text">Inv Amt.</div></th>
										<th style="text-align:center;width:90px;"><div class="th-text">AR Amt.</div></th>
										<th style="text-align:center;width:80px;"><div class="th-text">Due Date</div></th>
										<th style="text-align:center;"><div class="th-text">Elapsed Days</div></th>
									</tr>
								</thead>

								<tbody>
									<tr v-for="inv in invoices_with_ar" :key="inv.invoice_no" @click="gotoInvoiceDetail(inv)">
										<td>{{ inv.invoice_dn }}</td>
										<td>{{ inv.invoice_date }}</td>
										<td class="al_right">{{ inv.invoice_amount | toCurrency }}</td>
										<td class="al_right">{{ (inv.balance + inv.post_check_amount) | toCurrency }}</td>
										<td>{{ inv.due_date }}</td>
										<td class="al_right">
											<font v-if="inv.past_due_date > 0" style="color: red;">{{ inv.elapsed_days | commaSeparated }}</font>
											<font v-else>{{ inv.elapsed_days | commaSeparated }}</font>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div v-if="arViewable">
						<table class="list_tbl tbl_pointer" border="0">
							<thead>
								<tr>
									<th style="text-align:center;width:110px;"><div class="th-text">Inv No.</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">Inv Date</div></th>
									<th style="text-align:center;width:90px;"><div class="th-text">Inv Amt.</div></th>
									<th style="text-align:center;width:90px;"><div class="th-text">AR Amt.</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">Due Date</div></th>
									<th style="text-align:center;"><div class="th-text">Elapsed Days</div></th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td colspan="2" class="al_right">TOTAL</td>
									<td class="al_right">{{ totalInvoiceAmt | toCurrency }}</td>
									<td class="al_right">{{ totalArAmt | toCurrency }}</td>
									<td colspan="2"></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div>
					<h4 class="inner_h5">
						<template v-if="arViewable">Post-Dated Check</template>
						<template v-else>&nbsp;</template>
					</h4>
					<div class="fixed-table-container" style="height: 235px; overflow-x: auto;">
						<!-- <div class="table-wrapper" style="height:410px;"> -->
						<div v-if="arViewable" class="table-wrapper">
							<table class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:110px;"><div class="th-text">Check No.</div></th>
										<th style="text-align:center;width:80px;"><div class="th-text">Date</div></th>
										<th style="text-align:center;width:90px;"><div class="th-text">Check Amt.</div></th>
										<th style="text-align:center;width:90px;"><div class="th-text">Days</div></th>
										<th style="text-align:center;"><div class="th-text">Invoice(s)</div></th>
									</tr>
								</thead>

								<tbody>
									<tr v-for="ch in post_dated_checks" :key="ch.receipt_item_no">
										<td>{{ ch.check_no }}</td>
										<td>{{ ch.valid_receipt_date }}</td>
										<td class="al_right">{{ ch.ri_amount | toCurrency }}</td>
										<td class="al_right">{{ ch.elapsed_days | commaSeparated }}</td>
										<td>
											<p v-for="inv in ch.invoices" :key="inv.invoice_no" @click="gotoInvoiceDetail(inv)">{{ inv.invoice_dn }}</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div style="padding-left:25px;padding-top:20px;padding-bottom:20px;">
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoARHistory()">AR History</a>
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoBackOrder()">Back Order</a>
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoBestSellItem()">Best Sell Item</a>
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoCallTag()">Call Tag</a>
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoInventory()">Inventory</a>
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoInvoice()">Invoice</a>
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoItemInquiry()">Item Inquiry</a>
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoItemList()">Item List</a>
			<a href="javascript:;" type="button" class="menu_bt mgr_15" @click="gotoSalesOrder()">Sales Order</a>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'GoogleMap'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Select Location</template>
			<template slot="body">
				<GoogleMap :initialLocation="location" v-on:updateLocation="updateLocation" v-on:close="closeModal()" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Memo'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Partner Memo</template>
			<template slot="body">
				<MemoPopup :partner_code="partner.code" v-on:close="closeModal()" />
			</template>
		</Modal>

		<ShipToAddressManagement v-if="showModal && modalName == 'ShipToAddressManagement'" :modifiable="modifiable" :partner_code="partner.code" @close="closeModal()" @updateShipToAddr="closeModal()" />
	</div>
</template>

<script>
import { apiGetThirdPartyCustomersByCode, apiDeleteThirdPartyOrderCustomerById, apiInsertThirdPartyOrderCustomer, apiGetCustomerByThirdPartyCustomerId } from '@/api/shopify/shopify_order.js';
import { apiGetShopifyStoreList } from '@/api/shopify/shopify_common.js';
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectArList, apiSelectArHistory } from '@/api/receipt/index.js';
import {
	apiDetailIndex,
	apiSelectPartner,
	apiCheckPartnerExists,
	apiSelectNewPartnerCode,
	apiInsertPartner,
	apiUpdatePartner,
	apiDeletePartner,
	apiInsertPartnerDocInfo,
	apiDeletePartnerDocInfo,
	apiConfirmAddress,
	apiUpdatePart,
} from '@/api/partner/index.js';
import { apiDownloadFile, apiUploadFile } from '@/api/util.js';
// import { apiSelectCodeList } from '@/api/basicinfo/code.js';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import Modal from '@/components/common/Modal';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import GoogleMap from '@/components/common/GoogleMap';
import MemoPopup from '@/components/common/MemoPopup';
import ShipToAddressManagement from '@/components/common/ShipToAddressManagement.vue';
import { today, compareDate, dateStrDiff } from '@/utils/date.js';
import _ from 'lodash';

export default {
	data: function() {
		return {
			backUri: '/partner/partner_main',
			mode: 'add',
			partner: {
				partner_type: 'C',
				active_yn: 'Y',
				invoice_date_editable: true,
				show_credit: true,
			},
			docs: [],

			blockHistory: [],

			countries: [],
			businessTypes: [],
			grades: [],
			races: [],
			deliveryTypes: [],
			shipCharges: [],
			salesGroups: [],
			salesmans: [],
			paymentTerms: [],
			recipetTypes: [],
			arTypes: [],
			docTypes: [],
			territories: [],
			doc_type_code: null,
			doc_type_name: null,
			// depts: [],
			// salesTeams: [],

			// userTypes: [
			// 	{ value: 'staff', text: 'Office' },
			// 	{ value: 'salesman', text: 'Salesman' },
			// 	{ value: 'driver', text: 'Driver' },
			// 	{ value: 'whstaff', text: 'Warehouse Staff' },
			// ],

			modalName: '',
			showModal: false,

			currentTabPage: 0,
			tabHeight: 460,

			tabPages: ['General Info.', 'Biz Process Info.', 'Accounting Info.', 'Owner Info.', 'Documents'],

			initial_partner_type: null,

			profile: null,

			invoices_with_ar: [],
			ar_histories: [],

			search_partner_code: null,

			third_party_store_list: [],
			selected_third_party_store_no: null,
			third_party_customer_ids: [],
			new_program_customer_id: null,
		};
	},
	computed: {
		tabTitle() {
			return this.tabPages[this.currentTabPage];
		},
		location() {
			return {
				lat: this.partner.lat,
				lng: this.partner.lng,
				place_id: this.partner.place_id,
				address_detail: this.partner.address_detail,
				address_city: this.partner.address_city,
				address_state: this.partner.address_state,
				address_zipcode: this.partner.address_zipcode,
				country: this.partner.country,
			};
		},
		user: function() {
			return this.$session.get('user');
		},
		arViewableAuth() {
			let auth = false;
			if (this.user) {
				auth = this.user.admin_yn === 'Y'; // 기본적으로 admin은 볼 수 있게 설정

				if (!auth) {
					if (this.user.company_id === 'beautyplus') auth = this.user.user_id === 'ANNA';
					else if (this.user.company_id === 'newjigu') auth = true;
				}
			}

			return auth;
		},
		arViewable() {
			return this.mode === 'detail' && this.partner.partner_type !== 'V' && this.arViewableAuth;
		},
		modifiable() {
			//console.log(this.mode, this.partner.name);
			if (this.mode == 'detail' && !this.partner.name) return false;

			var menus = this.$session.get('menus');

			// var current_path = this.$router.history.current.path;
			// console.log('hmmm', current_path);
			// if (this.initial_partner_type == 'C') current_path = current_path.replace('partner', 'customer');
			// else if (this.initial_partner_type == 'V') current_path = current_path.replace('partner', 'vendor');
			// console.log('hmm2', current_path);

			for (var i = 0; i < menus.length; i++) {
				if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				//if ((menus[i].path == current_path || menus[i].path == current_path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		partModifiable() {
			if (this.mode == 'detail' && this.user.company_id == 'newjigu') {
				if (this.user.user_type == 'salesman' || this.user.admin_yn == 'Y') return true;
			}

			return false;
		},
		reformattedSalesmans() {
			return this.salesmans.map(sm => ({ code: sm.user_id, name: sm.name }));
		},
		ar_param() {
			return {
				paging_yn: 'N',
				real_outstanding_yn: 'Y',
				bill_to_code: this.partner.code,
				sort_key: 'invoice_date',
				sort_direction: 'ASC',
				exclude_void: true,
			};
		},
		post_dated_checks() {
			const res = [];
			const makeSimpleInv = el => ({ invoice_no: el.invoice_no, invoice_dn: el.invoice_dn, invoice_type: el.invoice_type });

			this.ar_histories
				.filter(el => el.ar_post_check) // post_check인 경우로 filtering
				.forEach(el => {
					// 화면에 표시될 요소로 배열(res) 구성
					const idx = res.findIndex(r => el.receipt_item_no === r.receipt_item_no);
					if (idx < 0) {
						res.push({
							receipt_item_no: el.receipt_item_no,
							check_no: el.check_no,
							valid_receipt_date: el.valid_receipt_date,
							ri_amount: el.ri_amount,
							invoices: [makeSimpleInv(el)],
							rep_invoice_date: el.invoice_date, // 가장 오래된 Invoice의 invoice_date를 대표값으로 하여 elapsed_days 계산
						});
					} else {
						res[idx].invoices.push(makeSimpleInv(el));
						if (compareDate(res[idx].rep_invoice_date, el.invoice_date) === 1) res[idx].rep_invoice_date = el.invoice_date;
					}
				});

			res.forEach(el => (el.elapsed_days = dateStrDiff(el.rep_invoice_date, el.valid_receipt_date)));

			return res;
		},
		totalInvoiceAmt() {
			return this.invoices_with_ar.reduce((prev, curr) => prev + curr.invoice_amount, 0);
		},
		totalArAmt() {
			return this.invoices_with_ar.reduce((prev, curr) => prev + (curr.balance + curr.post_check_amount), 0);
		},
		shopifyUsable() {
			const menus = this.$session.get('menus');
			let path = '/sales/shopify';
			let idx = menus.findIndex(mn => mn.path === path && mn.view_yn === 'Y' && !mn.hide);
			return idx > -1;
		},
	},
	watch: {
		currentTabPage: {
			immediate: true,
			handler(tab_num) {
				if (this.mode !== 'detail') return;

				const tab_name = this.tabPages[tab_num];
				if (tab_name.toUpperCase().indexOf('SHOPIFY') > -1) {
					this.getShopifyStoreList();
				}
			},
		},
		selected_third_party_store_no: {
			handler(store_no) {
				if (!store_no) {
					this.third_party_customer_ids = [];
				} else {
					this.getThirdPartyCustomersByCode();
				}
			},
		},
	},
	components: {
		GoogleMap,
		MemoPopup,
		Modal,
		CodeSelect,
		CustomDatePicker,
		PartnerSelect,
		ShipToAddressManagement,
	},
	methods: {
		async deleteThirdPartyCustomer(cust_no) {
			const { data } = await apiDeleteThirdPartyOrderCustomerById(cust_no);
			if (data.result === 'SUCCESS') {
				this.$toast.success('Delete Third Party Store Cust.');
				this.getThirdPartyCustomersByCode();
			} else this.$toast.error('Failed to Delete Third Party Store Cust.');
		},
		async addThirdPartyCustomer() {
			const checkValid = await this.checkValidThirdPartyCustId();
			if (!checkValid) return;

			const { data } = await apiInsertThirdPartyOrderCustomer(this.partner.code, this.new_program_customer_id, this.selected_third_party_store_no);
			if (data.result === 'SUCCESS') {
				this.$toast.success('Success to Add Third Party Store Cust.');
				this.getThirdPartyCustomersByCode();
			} else this.$toast.error('Failed to Add Third Party Store Cust.');
		},
		async checkValidThirdPartyCustId() {
			if (!this.new_program_customer_id) {
				this.$toast.error('Please, Input Cust ID.');
				return false;
			}

			this.new_program_customer_id = 'gid://shopify/Customer/' + this.new_program_customer_id;

			const { data } = await apiGetCustomerByThirdPartyCustomerId(this.selected_third_party_store_no, this.new_program_customer_id);
			if (data && data.cust_no) {
				this.$toast.error('Cust ID Already Exists.');
				return false;
			}

			return true;
		},
		async getShopifyStoreList() {
			const { data } = await apiGetShopifyStoreList();
			this.third_party_store_list = data || [];
			if (this.third_party_store_list.length > 0) this.selected_third_party_store_no = this.third_party_store_list[0].store_no;
		},
		async getThirdPartyCustomersByCode() {
			const { data } = await apiGetThirdPartyCustomersByCode(this.partner.code, this.selected_third_party_store_no);
			this.third_party_customer_ids = data || [];
		},
		async updatePart() {
			const { data } = await apiUpdatePart(this.partner);

			if (data.result) {
				this.$toast.success('Only Updatable Info(Business Type, Description, Owner Info, Contact Information Except Telephone 1) Saved Successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},

		async findPartner() {
			if (!this.search_partner_code) {
				this.$toast.error('Empty search string');
				return;
			}

			const { data } = await apiSelectPartner({
				code: this.search_partner_code,
				partner_code: this.search_partner_code,
			});

			if (!data.partner) {
				this.$toast.error('Partner information not found.');
				return;
			}

			this.partner.code = this.search_partner_code;
			this.search_partner_code = null;

			await this.selectPartner();
			await this.selectArList();
			await this.selectArHistory();
		},
		async confirmAddress() {
			if (!(this.partner && this.partner.address_detail && this.partner.address_city && this.partner.address_state)) {
				this.$toast.error('Please, Input Address, City and State.');
				return;
			}

			if (!(this.partner && ['US', 'USA'].includes(this.partner.country))) {
				this.$toast.error('Confirming Address is Only Served<br />When the Address is in USA.');
				return;
			}

			const { data } = await apiConfirmAddress(this.partner.address_detail, this.partner.address_city, this.partner.address_state);
			const status = data.resultStatus;
			const addressList = data.addressList;
			if (status !== 'SUCCESS') {
				this.$toast.error(status);
				return;
			}

			if (addressList.length > 1) {
				let msg = '';
				addressList.forEach((adr, index) => (msg += index + 1 + '. ' + adr.addressLine1 + ' ' + adr.city + ' ' + adr.state + ' <b>' + adr.zip5 + '-' + adr.zip4 + '</b><br />'));
				msg += 'Please Cofirm the Your Input Address.';
				this.$alertify.alert('Alert', msg);
			} else {
				const dash_idx = this.partner.address_zipcode.indexOf('-');
				const zip5 = addressList[0].zip5;
				const zip4 = addressList[0].zip4;
				let is_equals = false;

				if (dash_idx > -1) {
					if (this.partner.address_zipcode === zip5 + '-' + zip4) is_equals = true;
				} else {
					if (this.partner.address_zipcode === zip5) is_equals = true;
				}

				if (is_equals) this.$toast.success('Valid Address.');
				else this.$alertify.alert('Alert', 'Zip Code Provided by UPS: ' + zip5 + '-' + zip4);
			}
		},
		gotoBackOrder() {
			let routeData = this.$router.resolve({
				name: 'backOrder',
				query: {
					backUri: this.uri,
					ship_to_code: this.partner.code,
				},
			});
			window.open(routeData.href, 'herp_backorder');
		},
		gotoBestSellItem() {
			this.$alertify.alert('Alert', 'Under Deveopment');
		},
		gotoSalesOrder() {
			let routeData = this.$router.resolve({
				name: 'soMain',
				query: {
					backUri: this.uri,
					ship_to_code: this.partner.code,
					so_date_from: 'NON_SELECT',
					so_date_to: 'NON_SELECT',
				},
			});
			window.open(routeData.href, 'herp_so');
		},
		gotoInventory() {
			let routeData = this.$router.resolve({
				name: 'inventoryStatus',
				query: {
					backUri: this.uri,
				},
			});
			window.open(routeData.href, 'herp_inventory');
		},
		gotoItemList() {
			let routeData = this.$router.resolve({
				name: 'salesGoods',
				query: {
					backUri: this.uri,
					date_from: 'NON_SELECT',
					date_to: 'NON_SELECT',
					ship_tos_string: this.partner.code,
				},
			});
			window.open(routeData.href, 'herp_item');
		},
		gotoItemInquiry() {
			let routeData = this.$router.resolve({
				name: 'itemInquiry',
				query: {
					backUri: this.uri,
					partner_code: this.partner.code,
				},
			});
			window.open(routeData.href, 'herp_item_inquiry');
		},
		gotoInvoiceDetail(invoice) {
			const invoice_no = invoice.invoice_no;
			const invoice_type = invoice.invoice_type;
			if (!['S', 'R'].includes(invoice_type)) return; // 'A', 'B'타입 Invoice에 대한 상세화면 페이지는 없음.

			let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { invoice_no: invoice_no } });
			window.open(routeData.href, '_blank');
		},
		gotoInvoice() {
			let routeData = this.$router.resolve({
				name: 'invoiceMain',
				query: {
					backUri: this.uri,
					bill_to_code: this.partner.code,
					invoice_date_from: 'NON_SELECT',
					invoice_date_to: 'NON_SELECT',
				},
			});
			window.open(routeData.href, 'herp_invoice');
		},
		gotoARHistory() {
			let routeData = this.$router.resolve({
				name: 'arHistory',
				query: {
					backUri: this.uri,
					bill_to_code: this.partner.code,
					bill_to_name: this.partner.name,
					date_type_is_invoice: '1',
				},
			});
			window.open(routeData.href, 'herp_ar_history');
		},
		gotoCallTag() {
			let routeData = this.$router.resolve({
				name: 'callTag',
				query: {
					backUri: this.uri,
					ship_to_code: this.partner.code,
				},
			});
			window.open(routeData.href, 'herp_calltag');
		},
		blockStatusChanged() {
			//console.log(partner.blocked);
			if (!this.partner.blocked) this.partner.block_reason = null;
		},
		goBack() {
			window.history.go(-1);
		},
		clearAddress() {
			this.partner.address_detail = '';
			this.partner.address_detail2 = '';
			this.partner.address_city = '';
			this.partner.address_state = '';
			this.partner.address_zipcode = '';
			this.partner.country = '';
		},
		clearOwnerAddress() {
			this.partner.owner_address_detail = '';
			this.partner.owner_address_city = '';
			this.partner.owner_address_state = '';
			this.partner.owner_address_zipcode = '';
			this.partner.owner_country = '';
		},
		updateLocation: function(location) {
			if (location.lat) this.partner.lat = location.lat;
			if (location.lng) this.partner.lng = location.lng;
			if (location.place_id) this.partner.place_id = location.place_id;
			if (location.address_detail && !this.partner.address_detail) this.partner.address_detail = location.address_detail;
			if (location.address_city && !this.partner.address_city) this.partner.address_city = location.address_city;
			if (location.address_state && !this.partner.address_state) this.partner.address_state = location.address_state;
			if (location.address_zipcode && !this.partner.address_zipcode) this.partner.address_zipcode = location.address_zipcode;
			if (location.country && !this.partner.country) this.partner.country = location.country;

			//console.log(location);
			//this.user.place_id = placeId;
			//console.log('event received');
			//console.log(this.user);
		},
		selectTab(selectedTabPage) {
			this.currentTabPage = selectedTabPage;
		},
		async selectArHistory() {
			const { data } = await apiSelectArHistory(this.ar_param);
			this.ar_histories = data.arHistory;
		},
		async selectArList() {
			const { data } = await apiSelectArList(this.ar_param);
			this.invoices_with_ar = data.arList;
		},
		async selectPartner() {
			const { data } = await apiSelectPartner({
				code: this.partner.code,
				partner_code: this.partner.code,
				include_specialty: true,
			});

			if (!data.partner) {
				this.$toast.error('Partner information not found. You may have no permission.');
				return;
			}

			this.partner = data.partner;
			this.docs = data.docList;
			this.blockHistory = data.blockHistory;

			if (this.partner.ytd == null) this.partner.ytd = 0;
			//console.log(this.blockHistory);
			//console.log(this.partner);
			//console.log(this.docs);

			this.selectTab(this.currentTabPage);
		},
		setBusinessType(code) {
			if (code) this.partner.business_type_name = code.name;
			else this.partner.business_type_name = '';
		},
		setGrade(code) {
			if (code) this.partner.grade_name = code.name;
			else this.partner.grade_name = '';
		},
		setRace(code) {
			if (code) this.partner.race_name = code.name;
			else this.partner.race_name = '';
		},
		setTerritory(code) {
			if (code) this.partner.territory_name = code.name;
			else this.partner.territory_name = '';
		},
		setDeliveryType(code) {
			if (code) this.partner.delivery_type_name = code.name;
			else this.partner.delivery_type_name = '';

			if (this.partner.delivery_type_name.toUpperCase().startsWith('PICKUP')) {
				this.partner.cod_free_yn = 'Y';
				this.partner.handling_charge_free_yn = 'Y';
			}
		},
		setShipCharge(code) {
			if (code) this.partner.ship_charge_name = code.name;
			else this.partner.ship_charge_name = '';
		},
		setSalesGroup(code) {
			if (code) this.partner.sales_group_name = code.name;
			else this.partner.sales_group_name = '';
		},
		setSalesman(user) {
			if (user) this.partner.salesman_name = user.name;
			else this.partner.salesman_name = '';
		},
		setPaymentTerm(code) {
			if (code) this.partner.payment_term_name = code.name;
			else this.partner.payment_term_name = '';
		},
		setReceiptType(code) {
			if (code) this.partner.receipt_type_name = code.name;
			else this.partner.receipt_type_name = '';
		},
		setArType(code) {
			if (code) this.partner.ar_type_name = code.name;
			else this.partner.ar_type_name = '';
		},
		setDocType(code) {
			if (code) this.doc_type_name = code.name;
			else this.doc_type_name = '';
		},

		async deleteFile(doc) {
			//console.log(doc);
			if (confirm('Are you sure to delete the file?')) {
				const { data } = await apiDeletePartnerDocInfo(doc);
				if (data.result) {
					this.$toast.success('File deleted successfully');
					const idx = this.docs.findIndex(function(item) {
						return item.doc_no === doc.doc_no;
					});
					this.docs.splice(idx, 1);
				}
			}
		},
		async uploadFile() {
			const elem = this.$refs.uploadFile;
			elem.click();
		},
		async uploadFileConfirm() {
			var file = this.$refs.uploadFile.files[0];
			var response = await apiUploadFile(file);
			if (response.data.result) {
				var newFilename = response.data.filename;
				//this.$toast.success('File uploaded successfully');
				var newDoc = {
					partner_code: this.partner.code,
					doc_type_code: this.doc_type_code,
					doc_type_name: this.doc_type_name,
					original_filename: file.name,
					filename: newFilename,
					filesize: file.size,
				};
				response = await apiInsertPartnerDocInfo(newDoc);
				if (response.data.result) {
					this.$toast.success('File uploaded successfully');

					newDoc.doc_no = response.data.doc_no;
					//console.log(newDoc);
					this.docs.push(newDoc);

					this.$refs.uploadFile.value = null;
				}
			}
		},
		async downloadFile(doc) {
			//console.log(filename);
			await apiDownloadFile(doc.filename, doc.original_filename);
		},
		async checkExists() {
			const { data } = await apiCheckPartnerExists(this.partner);
			return data.result;
		},
		async checkNameExists() {
			const { data } = await apiCheckPartnerExists({ comparison: 'name', name: this.partner.name });
			return data.result;
		},
		async submit(stay) {
			//console.log('hmmm');
			if (!this.partner.code) {
				this.$toast.error('Empty Code');
				return;
			}

			if (!this.partner.name) {
				this.$toast.error('Empty Name');
				return;
			}

			if (!this.partner.grade_code) {
				this.$toast.error('Empty Grade');
				return;
			}

			//console.log(this.partner);

			var response;
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate Code');
					return;
				}
				response = await apiInsertPartner(this.partner);
			} else {
				response = await apiUpdatePartner(this.partner);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.mode = 'detail';
				this.$store.commit('setSubTitle', 'Partner -> Detail');
				//console.log(this.backUri);
				if (!stay) this.goBack();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async delUser() {
			if (!this.isErasable) return;
			if (confirm('Are you sure to delete the partner?')) {
				const { data } = await apiDeletePartner(this.partner);

				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.goBack();
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		async checkDup() {
			if (await this.checkExists()) {
				this.$toast.error('Duplicate Code');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		async checkDupName() {
			if (await this.checkNameExists()) {
				this.$toast.error('Duplicate Name');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		makePassword() {
			if (this.mode === 'add') {
				let code = this.partner.code;
				let zipcode = this.partner.address_zipcode;
				if (!_.isEmpty(code)) {
					let first = code.slice(0, 1);
					let other = _.isEmpty(zipcode) ? '00000' : zipcode;
					this.partner.password = first + other;
				}
			}
		},
		setDefaultCountry() {
			let res = this.$session.get('company').ship_address_country;
			// ship_address_country가 유효하지 않은 경우, 미국으로 Default Set
			if (!this.isValidCountryCode(res)) {
				if (this.isValidCountryCode('US')) res = 'US';
				else if (this.isValidCountryCode('USA')) res = 'USA';
			}

			this.partner.country = res;
			this.partner.owner_country = res;
		},
		isValidCountryCode(code) {
			return this.countries.findIndex(c => c.code === code) > -1;
		},
		addTabPages() {
			let idx = -1;

			const tab_name = 'Shopify Info.';
			idx = this.tabPages.indexOf(tab_name);
			if (this.shopifyUsable && this.partner.partner_type !== 'V') {
				if (idx < 0) this.tabPages.push(tab_name);
			} else {
				if (idx > -1) {
					this.tabPages.splice(idx, 1);
					this.currentTabPage = 0;
				}
			}
		},
		async index() {
			const { data } = await apiDetailIndex();

			this.countries = data.countryList;
			this.businessTypes = data.businessTypeList;
			this.grades = data.gradeList;
			this.races = data.raceList;
			this.deliveryTypes = data.deliveryTypeList;
			this.shipCharges = data.shipChargeList;
			this.salesGroups = data.salesGroupList;
			this.salesmans = data.salesmanList;
			this.paymentTerms = data.paymentTermList;
			this.recipetTypes = data.receiptTypeList;
			this.arTypes = data.arTypeList;
			this.docTypes = data.docTypeList;
			this.territories = data.territoryList;
			//console.log(this.territories);

			// Default Country Set
			if (this.mode === 'add') this.setDefaultCountry();
		},
		async setNewCustomerCode() {
			const { data } = await apiSelectNewPartnerCode();
			this.partner.code = data.new_customer_code;
			//console.log(data);
			// if (data.result) {
			// 	this.$toast.success('File deleted successfully');
			// 	const idx = this.docs.findIndex(function(item) {
			// 		return item.doc_no === doc.doc_no;
			// 	});
			// 	this.docs.splice(idx, 1);
			// }
		},
		async init() {
			await this.index();
			if (this.mode == 'detail') {
				await this.selectPartner();
				await this.selectArList();
				await this.selectArHistory();
			} else {
				this.partner.open_date = today();
			}
		},
	},
	created() {
		this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;
		this.initial_partner_type = this.$route.params.initial_partner_type;

		this.profile = this.$session.get('profile');

		this.$store.commit('setSideIndex', 8);
		this.$store.commit('setSelectedMenu', 'nav_li_partner_main');
		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Partner -> Add');
			if (this.initial_partner_type) this.partner.partner_type = this.initial_partner_type;
			//console.log(this.profile.show_credit);
			if (this.profile.default_show_credit == 'N') this.partner.show_credit = false;

			if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') this.partner.notice = 'OPEN ON ' + today('/');

			if (this.initial_partner_type == 'C') this.setNewCustomerCode();
		} else {
			this.$store.commit('setSubTitle', 'Partner -> Detail');
			this.partner.code = this.$route.query.code;
		}

		this.addTabPages();
		//console.log(this.profile);
		this.init();
		//console.log(this.backUri);

		// this.selectDepts();
		// this.selectSalesTeams();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style>
.menu_bt {
	background: #806128;
	color: #fff;
	line-height: 50px;
	height: 50px;
	width: 110px;
	display: inline-block;
	padding: 18 18px;
	vertical-align: center;
	text-align: center;
	font-size: 14px;
	font-weight: bold;
}
.menu_bt:hover {
	background: #868826;
}
</style>
